<template>
    <div>

    </div>
    <ModalMaster :controller="modalController" />
</template>
<script>
import { onMounted, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useModalStore from "../store/ModalStore"
import useLocaleStore from "../store/LocaleStore";
import useAccountStore from "../store/AccountStore"
import CallbackFlow from '../composable/CallbackFlow';
import useTheOne from '../composable/useTheOne';
import useAlertModal from '../composable/useAlertModal';
import useLoadingModal from '../composable/useLoadingModal'
import useModalSetup from "../composable/useModalSetup"

// components
import ModalMaster from '../component/Modal/ModalMaster.vue';
import Utility from '@/helper/Utility';

export default {
    name: 'TheOneCallback',
    mixins: [],
    data: function () { return {} },
    components: {
        ModalMaster
    },
    setup: function () {
        const route = useRoute()
        const router = useRouter()
        const ModalStore = useModalStore();

        const LocaleStore = useLocaleStore()
        const AccountStore = useAccountStore()
        useModalSetup(ModalStore)

        const { showApiErrorModal, onClickAlertModalOk } = useAlertModal(ModalStore)
        const { loadingModal } = useLoadingModal(ModalStore)

        // init flow
        const callbackFlow = CallbackFlow({
            mainAppName: "theone"
        },
            AccountStore,
            LocaleStore
        )
        const theOneService = useTheOne(callbackFlow.states)

        const goToLanding = function () {
            if (Utility.isEmptyStr(callbackFlow.states.query.accessKey)) {
                // legacy flow
                router.replace({
                    name: "theone_landing",
                    query: callbackFlow.states.query.toQuery()
                })
            } else {
                // modern flow
                let qs = {
                    accKey: callbackFlow.states.query.accessKey
                }
                router.replace({
                    name: "theone_landing",
                    query: qs
                })
            }
        }

        //#region setup events
        callbackFlow.events.onReady = () => {
            const authCode = route.query?.code ?? null
            const uniqueRefID = route.query?.state ?? null
            theOneService.initService()

            loadingModal.show()
            theOneService.methods.getProfile({
                authCode,
                uniqueRefID
            }).then((resp) => {
                console.log(resp)
                if (resp.data?.error != null) {
                    showApiErrorModal(LocaleStore.lbl.value.errors.login.title, { code: resp.data.error.code, message: resp.data.error.description }, {
                        errCode: resp.data.error.code,
                        btnOk: LocaleStore.lbl.value.base_button.close,
                        msg: LocaleStore.lbl.value.errors.login.message // override msg
                    })
                    onClickAlertModalOk(() => {
                        goToLanding()
                    })
                } else {
                    // set data to session storage
                    // sessionStorage.setItem("t1c.loginResult", JSON.stringify(resp.data))
                    // transform resp to query string then redirect to theone_landing
                    goToLanding()
                }
            }).catch((err) => {
                showApiErrorModal(LocaleStore.lbl.value.errors.login.title, err, {
                    errCode: err.code,
                    btnOk: LocaleStore.lbl.value.base_button.close,
                    msg: LocaleStore.lbl.value.errors.login.message
                })
                onClickAlertModalOk(() => {
                    goToLanding()
                })
            }).finally(() => {
                loadingModal.hide()
            })
        }
        callbackFlow.events.onError = (err) => {
            showApiErrorModal(LocaleStore.lbl.value.errors.login.title, err, {
                errCode: err.code,
                msg: LocaleStore.lbl.value.errors.login.message
            })
            onClickAlertModalOk(() => {
                goToLanding()
            })
        }
        //#endregion
        provide("ModalStore", ModalStore)
        provide("LocaleStore", LocaleStore)
        provide("AccountStore", AccountStore)
        provide("TheOneService", theOneService)

        // call api to get profile
        onMounted(() => {
            // init
            callbackFlow.init()
        })

        return {
            theOneService,
            modalController: ModalStore.methods.getModalController(),
        }
    },
};
</script>
